/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpestimatedticketsize_Error4Inputs */

const en_coinvestments_gpestimatedticketsize_error4 = /** @type {(inputs: Coinvestments_Gpestimatedticketsize_Error4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update estimated ticket size. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to update estimated ticket size. Please try again." |
*
* @param {Coinvestments_Gpestimatedticketsize_Error4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpestimatedticketsize_error4 = /** @type {((inputs?: Coinvestments_Gpestimatedticketsize_Error4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpestimatedticketsize_Error4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpestimatedticketsize_error4(inputs)
});
export { coinvestments_gpestimatedticketsize_error4 as "coInvestments_gpEstimatedTicketSize_error" }